// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const zAdminFeature = z.object({
    enabled: z.boolean().optional()
});

export const zAnalyticsFeature = z.object({
    enabled: z.boolean().optional()
});

export const zAnswerRequest = z.object({
    language: z.string().length(2).regex(/^(?!\s*$).+/),
    locationNumber: z.string().min(1).regex(/\d{5}/),
    query: z.string().min(5).max(1000).regex(/^(?!\s*$).+/)
});

/**
 * The source excerpts supplied to the model as grounding context.
 */
export const zAnswerSource = z.object({
    cited: z.boolean(),
    confidence: z.enum([
        'VERY_HIGH',
        'HIGH',
        'MEDIUM',
        'LOW',
        'NOT_AVAILABLE',
        'UNKNOWN_TO_SYSTEM'
    ]),
    contentUrl: z.string(),
    documentId: z.string(),
    excerpt: z.string(),
    excerptId: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    icon: z.string().nullish(),
    id: z.string(),
    name: z.string(),
    tags: z.array(z.string())
});

/**
 * Represents the status to update the plan assignment step to.
 */
export const zAssignedStepStatusRequest = z.object({
    status: z.enum(['INCOMPLETE', 'COMPLETE'])
});

/**
 * Represents the user's latest completion report of a plan.
 */
export const zAssignmentLatestCompletionReport = z.object({
    completionDate: z.iso.datetime(),
    expirationDate: z.iso.datetime().optional(),
    totalDurationInSeconds: z.number()
});

/**
 * Represents the user's progress of a step within a plan.
 */
export const zAssignmentStep = z.object({
    duration: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    eventId: z.string().optional(),
    result: z.enum(['PASS', 'FAIL']).optional(),
    score: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    status: z.enum(['INCOMPLETE', 'COMPLETE']).optional(),
    statusChanged: z.iso.datetime().optional(),
    statusChangedBy: z.string().optional(),
    stepId: z.string().optional(),
    totalQuestions: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional()
});

export const zAssistanceFeature = z.object({
    enabled: z.boolean().optional()
});

/**
 * Attributes
 *
 * Persistent attributes with temporary sourceSystemId adopted when present.
 */
export const zAttribute = z.object({
    name: z.string().optional(),
    value: z.string().optional()
});

/**
 * References
 *
 * References to documents on Xyleme in different languages
 */
export const zBaseReferenceDto = z.object({
    country: z.string().optional(),
    crawlStatus: z.string().optional(),
    documentId: z.string().optional(),
    icon: z.string().optional(),
    id: z.string().optional(),
    language: z.string().optional(),
    name: z.string().optional(),
    type: z.string().optional()
});

export const zBrowseDocument = z.object({
    contentApiUrl: z.string().optional(),
    contentUrl: z.string().optional(),
    icon: z.string().optional(),
    id: z.string().optional(),
    name: z.string().optional(),
    otherContentUrl: z.string().optional(),
    otherName: z.string().optional(),
    otherPrintUrl: z.string().optional(),
    printUrl: z.string().optional(),
    sourceSystem: z.enum([
        'XYLEME',
        'TRIDION',
        'BRIGHTCOVE',
        'GAME'
    ]).optional(),
    type: z.enum([
        'BRIGHTCOVE',
        'LEARNUPON',
        'PROCEDURE',
        'JOB_AID',
        'GAME',
        'ORG',
        'QUALITY_PHOTOS',
        'VIDEO',
        'PDF',
        'OPERATIONAL_REQUIREMENTS',
        'PODCAST',
        'SIMULATOR',
        'ELEARNING'
    ]).optional()
});

export const zCategory = z.object({
    country: z.string(),
    displayIndex: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    featured: z.boolean(),
    icon: z.string(),
    id: z.string(),
    lastModified: z.iso.datetime(),
    name: z.string(),
    subcategories: z.array(z.string()).optional()
});

/**
 * A category with its display identity.
 */
export const zCategoryModel = z.object({
    id: z.string(),
    name: z.string().nullish()
});

/**
 * Configurations
 *
 * Configuration
 */
export const zClientConfig = z.object({
    alert: z.boolean().optional(),
    build: z.number().optional(),
    description: z.record(z.string(), z.string()).optional(),
    minRequiredBuild: z.number().optional(),
    url: z.string().optional(),
    version: z.string().optional()
});

/**
 * Represents the request used to clone an existing plan as a system plan.
 */
export const zCloneAsSystemPlanRequest = z.object({
    allowTrainTogether: z.boolean().default(true),
    autoAssign: z.boolean().optional().default(false),
    businessModel: z.enum([
        'LICENSEE',
        'FRANCHISEE',
        'ALL'
    ]),
    category: z.string().min(1).regex(/^(?!\s*$).+/),
    dueDateOffsetInDays: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    expireAfterCompletionOffsetInDays: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    featured: z.boolean().optional().default(false),
    readonly: z.boolean().default(false),
    reassignBeforeExpirationOffsetInDays: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    type: z.enum([
        'STORE',
        'TEMPLATE',
        'COMPLIANCE',
        'ANCHOR'
    ])
});

export const zCloudFrontCookiesEntries = z.object({
    'CloudFront-Key-Pair-Id': z.string().optional(),
    'CloudFront-Policy': z.string().optional(),
    'CloudFront-Signature': z.string().optional()
});

export const zCloudFrontCookieGroup = z.object({
    cookies: zCloudFrontCookiesEntries.optional(),
    domain: z.string().optional(),
    expiresIn: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    maxAgeInSeconds: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    path: z.string().optional(),
    queryString: z.string().optional()
});

export const zComplianceConfigurationDto = z.object({
    enabled: z.boolean().optional()
});

export const zComplianceFeature = z.object({
    enabled: z.boolean().optional()
});

/**
 * Conflict Error
 *
 * Error model with http status CONFLICT (409)
 */
export const zConflictError = z.object({
    detail: z.string().optional(),
    error: z.string().optional(),
    instance: z.string().optional(),
    message: z.string().optional(),
    path: z.string().optional(),
    status: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    timestamp: z.iso.datetime().optional(),
    title: z.string().optional(),
    tracing: z.object({
        'X-B3-Sampled': z.string().optional(),
        'X-B3-SpanId': z.string().optional(),
        'X-B3-TraceId': z.string().optional()
    }).optional(),
    type: z.string().optional()
});

/**
 * Constraint Violation
 *
 * Used with BadRequestError to indicate a constraint violation occurred
 */
export const zConstraintViolation = z.object({
    message: z.string().optional(),
    path: z.string().optional()
});

/**
 * Bad Request Error
 *
 * Error model with http status BAD_REQUEST (400)
 */
export const zBadRequestError = z.object({
    detail: z.string().optional(),
    error: z.string().optional(),
    instance: z.string().optional(),
    message: z.string().optional(),
    path: z.string().optional(),
    status: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    timestamp: z.iso.datetime().optional(),
    title: z.string().optional(),
    tracing: z.object({
        'X-B3-Sampled': z.string().optional(),
        'X-B3-SpanId': z.string().optional(),
        'X-B3-TraceId': z.string().optional()
    }).optional(),
    type: z.string().optional(),
    violations: z.array(zConstraintViolation).optional()
});

export const zContentReference = z.object({
    businessModel: z.enum([
        'FRANCHISEE',
        'LIC',
        'CORP'
    ]).optional(),
    contentApiUrl: z.string().optional(),
    contentUrl: z.string().optional(),
    country: z.enum([
        'US',
        'CA',
        'PR',
        'SG',
        'GB'
    ]).optional(),
    createdAt: z.iso.datetime().optional(),
    entity: z.enum([
        'CFA',
        'LBM',
        'TG',
        'BAY_CENTER',
        'CFA_SUPPLY'
    ]).optional(),
    id: z.string().optional(),
    language: z.string().optional(),
    lastModified: z.iso.datetime().optional(),
    legacyId: z.string().optional(),
    name: z.string().optional(),
    otherContentUrl: z.string().optional(),
    otherName: z.string().optional(),
    otherPrintUrl: z.string().optional(),
    printUrl: z.string().optional(),
    sourceId: z.string().optional(),
    sourceSystem: z.enum([
        'XYLEME',
        'TRIDION',
        'BRIGHTCOVE',
        'GAME'
    ]).optional(),
    tags: z.array(z.string()).optional()
});

export const zCountryFeature = z.object({
    enabled: z.boolean().optional()
});

/**
 * Certificate
 *
 * Certificate information for a users completed course
 */
export const zCourseCertificate = z.object({
    expiration: z.iso.datetime().optional(),
    recertification: z.boolean().optional()
});

/**
 * Certificate
 */
export const zCourseCertificateEntity = z.object({
    expiration: z.iso.datetime().optional(),
    recertification: z.boolean().optional()
});

/**
 * Enrollments
 */
export const zComplianceCourseEnrollmentEntity = z.object({
    certificate: zCourseCertificateEntity.optional(),
    completedDate: z.iso.datetime().optional(),
    courseId: z.string().optional(),
    dueDate: z.iso.datetime().optional(),
    duration: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    enrolledDate: z.iso.datetime().optional(),
    enrollmentId: z.string().optional(),
    finalScore: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    hidden: z.boolean().optional(),
    mostRecentCompletedDate: z.iso.datetime().optional(),
    pathwayCourseId: z.string().optional(),
    percentComplete: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    startedDate: z.iso.datetime().optional(),
    status: z.string().optional()
});

/**
 * Courses
 *
 * AssignableChecklistResult
 */
export const zAssignableCourseResult = z.object({
    courseID: z.string().optional(),
    courseName: z.record(z.string(), z.string()).optional(),
    createdDate: z.iso.datetime().optional(),
    enabled: z.boolean().optional(),
    enrollments: z.record(z.string(), zComplianceCourseEnrollmentEntity).optional(),
    id: z.string().optional()
});

export const zCourseEntity = z.object({
    assignmentType: z.string().optional(),
    capabilities: z.string().optional(),
    countriesToAssign: z.array(z.string()).optional(),
    courseDescription: z.string().optional(),
    courseId: z.string().optional(),
    courseLength: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    courseSkill: z.string().optional(),
    courseType: z.string().optional(),
    crawlStatus: z.string().optional(),
    datePublished: z.iso.datetime().optional(),
    documentId: z.string().optional(),
    episode: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    estimatedTime: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    expiration: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    format: z.string().optional(),
    id: z.string().optional(),
    language: z.string().optional(),
    lastIndexed: z.iso.datetime().optional(),
    name: z.record(z.string(), z.string()).optional(),
    relatedSourceId: z.string().optional(),
    season: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    sensitive: z.boolean().optional(),
    sourceId: z.string().optional(),
    statesToAssign: z.array(z.string()).optional(),
    thumbnailImageUrl: z.string().optional(),
    type: z.string().optional()
});

/**
 * Heartbeat Information about course like the totalTime and incrementalTime
 */
export const zCourseHeartbeat = z.object({
    interval: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
});

export const zCreatePlanFeature = z.object({
    enabled: z.boolean().optional()
});

export const zCreateQuizFeature = z.object({
    enabled: z.boolean().optional()
});

/**
 * CustomDataFieldValues
 */
export const zCustomDataFieldValue = z.object({
    definition_id: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    value: z.string().optional()
});

export const zCourse = z.object({
    capabilities: z.string().optional(),
    countriesToAssign: z.array(z.string()).optional(),
    country: z.string().optional(),
    courseType: z.string().optional(),
    course_length_unit: z.string().optional(),
    crawlStatus: z.string().optional(),
    created_at: z.iso.datetime().optional(),
    customDataFieldValues: z.array(zCustomDataFieldValue).optional(),
    date_published: z.iso.datetime().optional(),
    description_text: z.string().optional(),
    difficulty_level: z.string().optional(),
    documentId: z.string().optional(),
    episode: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    icon: z.string().optional(),
    id: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    language: z.string().optional(),
    license_expires: z.iso.datetime().optional(),
    minute_length: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    name: z.string().optional(),
    number_of_modules: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    relatedSourceId: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    season: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    source_id: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    thumbnail_image_url: z.string().optional(),
    type: z.string().optional(),
    version: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional()
});

/**
 * An answer option for a Classic (V1) custom quiz question.
 */
export const zCustomQuizAnswer = z.object({
    answer: z.record(z.string(), z.string().max(750)),
    correct: z.boolean().nullish(),
    id: z.record(z.string(), z.string()).nullish(),
    referenceId: z.record(z.string(), z.string()).nullish()
});

/**
 * A Classic (V1) multiple-choice question on a custom quiz.
 */
export const zCustomQuizQuestion = z.object({
    answers: z.array(zCustomQuizAnswer).min(2).max(2147483647),
    id: z.record(z.string(), z.string()).nullish(),
    question: z.record(z.string(), z.string().max(750)),
    questionType: z.string().nullish(),
    referenceId: z.record(z.string(), z.string()).nullish()
});

export const zDatasetExperimentRequest = z.object({
    datasetName: z.string().min(1).regex(/^(?!\s*$).+/),
    description: z.string().nullish(),
    locationNumber: z.string().regex(/\d{5}/).nullish(),
    model: z.enum([
        'GEMINI_2_5_FLASH',
        'GEMINI_2_5_FLASH_LITE',
        'GEMINI_3_1_FLASH_LITE',
        'GEMINI_3_5_FLASH',
        'GEMINI_3_5_FLASH_LITE'
    ]).optional(),
    promptLabel: z.string().regex(/.*\S.*/).nullish(),
    promptName: z.string().regex(/.*\S.*/).nullish(),
    queryPreprocessorPromptLabel: z.string().regex(/.*\S.*/).nullish(),
    queryPreprocessorPromptName: z.string().regex(/.*\S.*/).nullish(),
    temperature: z.number().gte(0).lte(2).nullish()
});

/**
 * Response returned when a dataset experiment is accepted for processing.
 */
export const zDatasetExperimentResponse = z.object({
    runName: z.string(),
    status: z.string()
});

/**
 * Document
 */
export const zDocument = z.object({
    enabled: z.boolean(),
    format: z.string().nullable(),
    icon: z.string().nullable(),
    id: z.string(),
    lastModified: z.iso.datetime().nullable(),
    lastModifiedBy: z.string().nullable(),
    name: z.record(z.string(), z.string()),
    type: z.string().nullable()
});

/**
 * Document
 */
export const zDocumentDto = z.object({
    enabled: z.boolean().optional(),
    format: z.string().optional(),
    icon: z.string().optional(),
    id: z.string().optional(),
    lastModified: z.iso.datetime().optional(),
    lastModifiedBy: z.string().optional(),
    marketTest: z.boolean().optional(),
    name: z.record(z.string(), z.string()).optional(),
    references: z.record(z.string(), zBaseReferenceDto).optional(),
    type: z.string().optional()
});

/**
 * Documents
 */
export const zDocumentsRequest = z.object({
    documentList: z.array(zDocumentDto).optional()
});

/**
 * A dataset used for experiments.
 */
export const zExperimentDataset = z.object({
    description: z.string().nullish(),
    id: z.string(),
    name: z.string()
});

/**
 * A LangFuse prompt available for dataset experiments.
 */
export const zExperimentPrompt = z.object({
    labels: z.array(z.string()).nullish(),
    name: z.string(),
    tags: z.array(z.string()).nullish(),
    versions: z.array(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })).nullish()
});

/**
 * Response containing available experiment configuration.
 */
export const zExperimentsConfigResponse = z.object({
    datasetNames: z.array(zExperimentDataset),
    models: z.array(z.enum([
        'GEMINI_2_5_FLASH',
        'GEMINI_2_5_FLASH_LITE',
        'GEMINI_3_1_FLASH_LITE',
        'GEMINI_3_5_FLASH',
        'GEMINI_3_5_FLASH_LITE'
    ])),
    prompts: z.array(zExperimentPrompt)
});

/**
 * Populated when requested locations are in a state that requires a food safety letter to be automatically
 * shown in plan reporting. This field will not be included if the requested locations are not in states that require
 * a letter to be shown or if the plan is not the food safety compliance plan.
 *
 */
export const zFoodSafetyLetter = z.object({
    content: z.string(),
    contentType: z.string(),
    locations: z.array(z.string()),
    size: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    state: z.string().length(2)
});

/**
 * Forbidden Error
 *
 * Error model with http status FORBIDDEN (403)
 */
export const zForbiddenError = z.object({
    detail: z.string().optional(),
    error: z.string().optional(),
    instance: z.string().optional(),
    message: z.string().optional(),
    path: z.string().optional(),
    status: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    timestamp: z.iso.datetime().optional(),
    title: z.string().optional(),
    tracing: z.object({
        'X-B3-Sampled': z.string().optional(),
        'X-B3-SpanId': z.string().optional(),
        'X-B3-TraceId': z.string().optional()
    }).optional(),
    type: z.string().optional()
});

/**
 * Client Configuration
 */
export const zFrontEndPropertiesResponse = z.object({
    configuration: z.record(z.string(), zClientConfig).optional(),
    cssFileUri: z.string()
});

export const zIdentityUser = z.object({
    adId: z.string().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    locations: z.array(z.string()).optional(),
    name: z.string().optional(),
    personId: z.string().optional(),
    prefName: z.string().optional(),
    source: z.enum([
        'TM_API',
        'WASB_API',
        'AUTH_TOKEN'
    ]).optional(),
    startDate: z.iso.datetime().optional(),
    username: z.string().optional()
});

/**
 * Internal Server Error
 *
 * Error model with http status INTERNAL_SERVER_ERROR (500)
 */
export const zInternalServerError = z.object({
    detail: z.string().optional(),
    error: z.string().optional(),
    instance: z.string().optional(),
    message: z.string().optional(),
    path: z.string().optional(),
    status: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    timestamp: z.iso.datetime().optional(),
    title: z.string().optional(),
    tracing: z.object({
        'X-B3-Sampled': z.string().optional(),
        'X-B3-SpanId': z.string().optional(),
        'X-B3-TraceId': z.string().optional()
    }).optional(),
    type: z.string().optional()
});

/**
 * IntlSubtitle
 */
export const zIntlSubtitle = z.object({
    documents: z.array(zDocument),
    enabled: z.boolean(),
    icon: z.string().nullable(),
    id: z.string(),
    lastModifiedBy: z.string(),
    name: z.record(z.string(), z.string()),
    visibleDocuments: z.array(z.string())
});

/**
 * IntlSubcategory
 */
export const zIntlSubcategory = z.object({
    enabled: z.boolean(),
    icon: z.string().nullable(),
    id: z.string(),
    lastModifiedBy: z.string(),
    name: z.record(z.string(), z.string()),
    subtitles: z.array(zIntlSubtitle)
});

/**
 * IntlCategory
 */
export const zIntlCategory = z.object({
    country: z.string(),
    displayIndex: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    enabled: z.boolean(),
    featured: z.boolean(),
    icon: z.string().nullable(),
    id: z.string(),
    lastModifiedBy: z.string(),
    leadershipOnly: z.boolean(),
    locationTypes: z.array(z.string()).nullable(),
    name: z.record(z.string(), z.string()),
    subcategories: z.array(zIntlSubcategory)
});

/**
 * Subtitles
 *
 * IntlSubtitle
 */
export const zIntlSubtitleDto = z.object({
    documents: z.array(zDocumentDto).min(1).max(2147483647),
    enabled: z.boolean().optional(),
    icon: z.string().min(1).regex(/^(?!\s*$).+/),
    id: z.string().optional(),
    lastModifiedBy: z.string().optional(),
    name: z.record(z.string(), z.string()),
    visibleDocuments: z.array(z.string()).optional()
});

/**
 * Subcategories
 *
 * IntlSubcategory
 */
export const zIntlSubcategoryDto = z.object({
    enabled: z.boolean().optional(),
    icon: z.string().optional(),
    id: z.string().optional(),
    lastModifiedBy: z.string().optional(),
    name: z.record(z.string(), z.string()).optional(),
    subtitles: z.array(zIntlSubtitleDto).optional()
});

/**
 * IntlCategory
 */
export const zIntlCategoryDto = z.object({
    country: z.string().optional(),
    displayIndex: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    enabled: z.boolean().optional(),
    featured: z.boolean().optional(),
    icon: z.string().optional(),
    id: z.string().optional(),
    lastModifiedBy: z.string().optional(),
    leadershipOnly: z.boolean().optional(),
    locationTypes: z.array(z.string()).optional(),
    name: z.record(z.string(), z.string()).optional(),
    subcategories: z.array(zIntlSubcategoryDto).optional()
});

/**
 * Subtitles
 */
export const zIntlSubtitleEntity = z.object({
    documents: z.array(z.string()).optional(),
    enabled: z.boolean().optional(),
    icon: z.string().optional(),
    id: z.string().optional(),
    lastModifiedBy: z.string().optional(),
    name: z.record(z.string(), z.string()).optional(),
    visibleDocuments: z.array(z.string()).optional()
});

/**
 * Subcategories
 */
export const zIntlSubcategoryEntity = z.object({
    enabled: z.boolean().optional(),
    icon: z.string().optional(),
    id: z.string().optional(),
    lastModifiedBy: z.string().optional(),
    name: z.record(z.string(), z.string()).optional(),
    subtitles: z.array(zIntlSubtitleEntity).optional()
});

export const zIntlCategoryEntity = z.object({
    country: z.string().optional(),
    displayIndex: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    enabled: z.boolean().optional(),
    featured: z.boolean().optional(),
    icon: z.string().optional(),
    id: z.string().optional(),
    lastModifiedBy: z.string().optional(),
    leadershipOnly: z.boolean().optional(),
    locationTypes: z.array(z.string()).optional(),
    name: z.record(z.string(), z.string()).optional(),
    subcategories: z.array(zIntlSubcategoryEntity).optional()
});

/**
 * CategoriesDTO
 */
export const zIntlCategoriesDto = z.object({
    categories: z.array(zIntlCategoryEntity).optional(),
    featured: z.array(zIntlCategoryEntity).optional()
});

export const zLanguageFeature = z.object({
    enabled: z.boolean().optional()
});

export const zLicenseeFeature = z.object({
    enabled: z.boolean().optional()
});

export const zLocationFeature = z.object({
    enabled: z.boolean().optional()
});

/**
 * The user's permissions for the location.
 */
export const zLocationPermissions = z.object({
    canCreatePlan: z.boolean(),
    canManageQuizzes: z.boolean()
});

/**
 * FoodSafetyLetters
 *
 * Populated when requested locations are in a state that requires a food safety letter to be automatically shown in compliance reporting. This field will be null if requested locations are not in states that require a letter to be shown or if the course is not a food safety compliance course.
 */
export const zLocationsFoodSafetyLetter = z.object({
    foodSafetyLetter: zFoodSafetyLetter.optional(),
    locations: z.array(z.string()).optional()
});

export const zManagePlanFeature = z.object({
    enabled: z.boolean().optional()
});

export const zMonitoringFeature = z.object({
    enabled: z.boolean().optional()
});

export const zName = z.object({
    language: z.string().optional(),
    value: z.string().optional()
});

/**
 * NotFound Error
 *
 * Error model with http status NOT_FOUND (404)
 */
export const zNotFoundError = z.object({
    detail: z.string().optional(),
    error: z.string().optional(),
    instance: z.string().optional(),
    message: z.string().optional(),
    path: z.string().optional(),
    status: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    timestamp: z.iso.datetime().optional(),
    title: z.string().optional(),
    tracing: z.object({
        'X-B3-Sampled': z.string().optional(),
        'X-B3-SpanId': z.string().optional(),
        'X-B3-TraceId': z.string().optional()
    }).optional(),
    type: z.string().optional()
});

/**
 * Operator info for the location
 */
export const zOperator = z.object({
    id: z.string().optional()
});

/**
 * Location the user is permitted to access
 */
export const zLocationDetails = z.object({
    areaSupportTeam: z.string().optional(),
    businessModel: z.enum([
        'FRANCHISEE',
        'LIC',
        'CORP'
    ]).optional(),
    country: z.string().optional(),
    entity: z.enum([
        'CFA',
        'LBM',
        'TG',
        'BAY_CENTER',
        'CFA_SUPPLY'
    ]).optional(),
    hasInterimManager: z.boolean(),
    market: z.string().optional(),
    name: z.string().optional(),
    number: z.string().optional(),
    operator: zOperator.optional(),
    region: z.string().optional(),
    state: z.string().optional(),
    type: z.string().optional()
});

export const zOperatorDto = z.object({
    id: z.string().optional(),
    locations: z.array(z.string()).optional(),
    name: z.string().optional()
});

/**
 * Represents the request used to update auto-assign settings for a plan.
 */
export const zPatchAutoAssignRequest = z.object({
    autoAssign: z.boolean().default(false),
    dueDateOffsetInDays: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional()
});

/**
 * Represents the request used to archive or unarchive a plan.
 */
export const zPatchStatusRequest = z.object({
    status: z.enum(['INACTIVE', 'ACTIVE'])
});

export const zPathwayUser = z.object({
    adId: z.string().optional(),
    admin: z.boolean().optional(),
    audience: z.enum([
        'UNKNOWN',
        'CONTRACTOR_AUDIENCE',
        'LICENSEE_AUDIENCE',
        'OPERATOR_AUDIENCE',
        'STAFF_AUDIENCE',
        'TEAM_MBR_AUDIENCE'
    ]).optional(),
    birthDate: z.iso.date().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    locationList: z.array(z.string()).optional(),
    name: z.string().optional(),
    personId: z.string().optional(),
    prefName: z.string().optional(),
    startDate: z.iso.date().optional(),
    username: z.string().optional()
});

/**
 * Represents the user information for a report.
 */
export const zPathwayUserReport = z.object({
    birthDate: z.iso.date().optional(),
    firstName: z.string(),
    id: z.string(),
    lastName: z.string(),
    locations: z.array(z.string()),
    name: z.string(),
    prefName: z.string().optional(),
    startDate: z.iso.date().optional()
});

/**
 * Authorized user locations
 */
export const zPermittedLocation = z.object({
    location: zLocationDetails,
    ownerId: z.string(),
    ownerType: z.enum([
        'SUPPORT_CENTER',
        'LOCATION',
        'OPERATOR',
        'SELF'
    ]),
    permissions: zLocationPermissions,
    roles: z.array(z.enum([
        'LOGIN',
        'TRAINER',
        'LEADER',
        'OPERATOR',
        'LICENSEESTAFF',
        'STAKEHOLDER',
        'ADMIN'
    ]))
});

/**
 * UserData
 *
 * List of User Report Data
 */
export const zPersonCourseReportDto = z.object({
    birthDate: z.iso.date().optional(),
    certificate: zCourseCertificate.optional(),
    courseCompletionDate: z.iso.date().optional(),
    courseScore: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    courseStatus: z.string().optional(),
    dueDate: z.iso.datetime().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional()
});

export const zCourseReportDto = z.object({
    courseId: z.string().optional(),
    courseName: z.string().optional(),
    foodSafetyLetters: z.array(zLocationsFoodSafetyLetter).optional(),
    locations: z.array(z.string()).optional(),
    sensitive: z.boolean().optional(),
    timeStamp: z.iso.datetime().optional(),
    userData: z.array(zPersonCourseReportDto).optional()
});

/**
 * Represents a user's plan assignment.
 */
export const zPlanAssignment = z.object({
    completionDate: z.iso.datetime().optional(),
    created: z.iso.datetime().optional(),
    createdBy: z.string().optional(),
    dueDate: z.iso.date().optional(),
    id: z.string().optional(),
    latestCompletionReport: zAssignmentLatestCompletionReport.optional(),
    legacyId: z.string().optional(),
    modified: z.iso.datetime().optional(),
    modifiedBy: z.string().optional(),
    planId: z.string().optional(),
    status: z.enum([
        'NOT_STARTED',
        'IN_PROGRESS',
        'COMPLETED',
        'UNASSIGNED'
    ]).optional(),
    steps: z.array(zAssignmentStep).optional(),
    stepsComplete: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    userId: z.string().optional()
});

/**
 * Represents the request used to assign plans to users.
 */
export const zPlanAssignmentRequest = z.object({
    dueDate: z.iso.date().optional(),
    userIds: z.array(z.string()).min(1)
});

/**
 * Represents the request used to clone an existing plan.
 */
export const zPlanCloneRequest = z.object({
    name: z.record(z.string(), z.string()),
    ownerId: z.string().min(1).regex(/^(?!\s*$).+/)
});

export const zPlanCreateRequest = z.object({
    name: z.record(z.string(), z.string()),
    ownerId: z.string().min(1).regex(/^(?!\s*$).+/)
});

/**
 * Request body for patching a plan name.
 */
export const zPlanNamePatchRequest = z.object({
    name: z.record(z.string(), z.string())
});

/**
 * Represents the user's plan permissions.
 */
export const zPlanPermissions = z.object({
    archive: z.boolean(),
    assign: z.boolean(),
    delete: z.boolean(),
    edit: z.boolean(),
    markAllStepsAndPlanComplete: z.boolean(),
    remove: z.boolean(),
    reset: z.boolean(),
    trainTogether: z.boolean(),
    updateDueDate: z.boolean()
});

/**
 * Rewrite plan step resource references from one resource CRN to another.
 */
export const zPlanResourceReferenceRewriteRequest = z.object({
    fromLegacyId: z.string().nullish(),
    fromResourceId: z.string().min(1).regex(/^(?!\s*$).+/),
    toResourceId: z.string().min(1).regex(/^(?!\s*$).+/)
});

/**
 * Accepted plan-job for an asynchronous resource-reference rewrite.
 */
export const zPlanResourceReferenceRewriteResponse = z.object({
    jobId: z.string()
});

/**
 * Represents the request used to unassign plans to users.
 */
export const zPlanUnassignmentRequest = z.object({
    userIds: z.array(z.string()).optional()
});

/**
 * Represents a set of URLs.
 */
export const zPlanUrlSet = z.object({
    urlSet: z.record(z.string(), z.string()).optional()
});

/**
 * Represents the user's progress on a plan.
 */
export const zPlanUserReport = z.object({
    certificateExpirationDate: z.iso.date().optional(),
    completionDate: z.iso.date().optional(),
    dueDate: z.iso.date().optional(),
    latestCompletionReport: zAssignmentLatestCompletionReport.optional(),
    status: z.enum([
        'NOT_STARTED',
        'IN_PROGRESS',
        'COMPLETED',
        'UNASSIGNED'
    ]).optional(),
    stepsComplete: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    timeTakenInSeconds: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    user: zPathwayUserReport.optional()
});

/**
 * A summary report for a user's assignment within a plan.
 */
export const zPlanUserSummaryReport = z.object({
    latestCompletionReport: zAssignmentLatestCompletionReport.optional(),
    status: z.enum([
        'NOT_STARTED',
        'IN_PROGRESS',
        'COMPLETED'
    ]).optional(),
    userId: z.string().optional()
});

/**
 * Represents a summary report of a plan
 */
export const zPlanReport = z.object({
    activeCertificates: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    assignedUsers: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    category: z.string(),
    completedUsers: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    created: z.iso.datetime(),
    description: z.record(z.string(), z.string()).optional(),
    id: z.string(),
    latestSummaryReports: z.array(zPlanUserSummaryReport).optional(),
    legacyId: z.string().optional(),
    name: z.record(z.string(), z.string()),
    ownerId: z.string(),
    ownerType: z.enum([
        'SUPPORT_CENTER',
        'LOCATION',
        'OPERATOR',
        'SELF'
    ]),
    readonly: z.boolean(),
    type: z.enum([
        'STORE',
        'TEMPLATE',
        'COMPLIANCE',
        'ANCHOR'
    ])
});

/**
 * Represents a user's report for a specified plans
 */
export const zPlanUsersReport = z.object({
    category: z.string(),
    created: z.iso.datetime(),
    description: z.record(z.string(), z.string()).optional(),
    foodSafetyLetters: z.array(zFoodSafetyLetter).optional(),
    id: z.string(),
    legacyId: z.string().optional(),
    name: z.record(z.string(), z.string()),
    ownerId: z.string(),
    ownerType: z.enum([
        'SUPPORT_CENTER',
        'LOCATION',
        'OPERATOR',
        'SELF'
    ]),
    planUserReports: z.array(zPlanUserReport).optional(),
    totalSteps: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    type: z.enum([
        'STORE',
        'TEMPLATE',
        'COMPLIANCE',
        'ANCHOR'
    ])
});

export const zPlansFeature = z.object({
    create: zCreatePlanFeature.optional(),
    enabled: z.boolean().optional(),
    manage: zManagePlanFeature.optional()
});

/**
 * Represents a custom quiz.
 */
export const zQuiz = z.object({
    created: z.iso.datetime(),
    createdBy: z.string(),
    id: z.string(),
    lastModified: z.iso.datetime(),
    lastModifiedBy: z.string(),
    name: z.record(z.string(), z.string()),
    operatorId: z.string(),
    ownerId: z.string(),
    ownerType: z.enum([
        'OPERATOR',
        'LOCATION',
        'SUPPORT_CENTER',
        'SELF'
    ]),
    typeFormId: z.string(),
    v2: z.boolean()
});

/**
 * Request to create a custom quiz.
 */
export const zQuizCreateRequest = z.object({
    location: z.string().nullish(),
    name: z.record(z.string(), z.string().max(750)),
    operatorId: z.string().nullish(),
    ownerId: z.string().nullish(),
    passingGrade: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    primaryLanguage: z.enum(['en', 'es']).optional(),
    questions: z.array(zCustomQuizQuestion).min(1).max(2147483647),
    v2: z.boolean()
});

/**
 * Response returned when a custom quiz is created.
 */
export const zQuizCreateResponse = z.object({
    id: z.string().min(1).regex(/^(?!\s*$).+/),
    typeFormId: z.string().nullish()
});

/**
 * Full details for a custom quiz.
 */
export const zQuizDetail = z.object({
    formId: z.string().min(1).regex(/^(?!\s*$).+/),
    name: z.record(z.string(), z.string()),
    operatorId: z.string().min(1).regex(/^(?!\s*$).+/),
    ownerId: z.string().min(1).regex(/^(?!\s*$).+/),
    passingGrade: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    primaryLanguage: z.enum(['en', 'es']).optional(),
    questions: z.array(zCustomQuizQuestion).min(1).max(2147483647),
    quizId: z.string().min(1).regex(/^(?!\s*$).+/),
    typeFormId: z.string().min(1).regex(/^(?!\s*$).+/),
    v2: z.boolean()
});

/**
 * Request body for patching a quiz name.
 */
export const zQuizNamePatchRequest = z.object({
    name: z.record(z.string(), z.string().max(750))
});

/**
 * Quiz step within a plan.
 */
export const zQuizStep = z.object({
    id: z.string(),
    name: z.record(z.string(), z.string()),
    quizCrnId: z.string().readonly().optional(),
    quizId: z.string().min(1).regex(/^(?!\s*$).+/),
    quizV2: z.boolean().readonly().optional(),
    type: z.enum(['quiz'])
});

/**
 * Request to update a custom quiz.
 */
export const zQuizUpdateRequest = z.object({
    name: z.record(z.string(), z.string().max(750)),
    passingGrade: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    questions: z.array(zCustomQuizQuestion).min(1).max(2147483647)
});

/**
 * Response returned when a custom quiz is updated.
 */
export const zQuizUpdateResponse = z.object({
    id: z.string().min(1).regex(/^(?!\s*$).+/)
});

export const zQuizzesFeature = z.object({
    create: zCreateQuizFeature.optional(),
    enabled: z.boolean().optional()
});

/**
 * Represents a request to subscribe an operator/location to a readonly plan.
 */
export const zReadonlySubscriptionRequest = z.object({
    optedIn: z.boolean(),
    ownerId: z.string().min(1).regex(/^(?!\s*$).+/)
});

/**
 * Contains subscription settings for opted-in readonly plans
 */
export const zReadonlySubscriptionSettings = z.object({
    lastOptedInAt: z.iso.datetime(),
    optedIn: z.boolean()
});

export const zReportingPlansFeature = z.object({
    enabled: z.boolean().optional()
});

/**
 * Represents the user ids who plan steps are being reset.
 */
export const zResetPlanStepsRequest = z.object({
    userIds: z.array(z.string()).min(1)
});

export const zResource = z.object({
    icon: z.string().optional(),
    id: z.string().optional(),
    legacyId: z.string().optional(),
    name: z.array(zName).optional(),
    references: z.array(zContentReference).optional(),
    type: z.enum([
        'BRIGHTCOVE',
        'LEARNUPON',
        'PROCEDURE',
        'JOB_AID',
        'GAME',
        'ORG',
        'QUALITY_PHOTOS',
        'VIDEO',
        'PDF',
        'OPERATIONAL_REQUIREMENTS',
        'PODCAST',
        'SIMULATOR',
        'ELEARNING'
    ]).optional()
});

/**
 * Category entry for a subtitle placement after a resource swap.
 */
export const zResourceSwapCategory = z.object({
    categoryId: z.string(),
    country: z.string(),
    displayIndex: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    path: z.array(zCategoryModel),
    visible: z.boolean()
});

/**
 * Identifies the persistent and temporary resources to swap.
 */
export const zResourceSwapRequest = z.object({
    persistentResourceId: z.string().min(1).regex(/^(?!\s*$).+/),
    temporaryResourceId: z.string().min(1).regex(/^(?!\s*$).+/)
});

/**
 * Resource swap result and browse placements requiring manual update.
 */
export const zResourceSwapResponse = z.object({
    affectedCategories: z.array(zResourceSwapCategory),
    persistentResourceId: z.string(),
    temporaryResourceId: z.string(),
    temporaryResourceLegacyId: z.string().nullish()
});

export const zRumFeature = z.object({
    enabled: z.boolean().optional()
});

/**
 * the result search results.
 */
export const zSearchDocument = z.object({
    contentApiUrl: z.string().optional(),
    contentUrl: z.string().optional(),
    icon: z.string().optional(),
    id: z.string().optional(),
    lastModified: z.string().optional(),
    name: z.string().optional(),
    otherContentUrl: z.string().optional(),
    otherName: z.string().optional(),
    otherPrintUrl: z.string().optional(),
    printUrl: z.string().optional(),
    searchId: z.string(),
    sourceSystem: z.enum([
        'XYLEME',
        'TRIDION',
        'BRIGHTCOVE',
        'GAME'
    ]).optional(),
    tags: z.array(z.string()).optional(),
    type: z.enum([
        'BRIGHTCOVE',
        'LEARNUPON',
        'PROCEDURE',
        'JOB_AID',
        'GAME',
        'ORG',
        'QUALITY_PHOTOS',
        'VIDEO',
        'PDF',
        'OPERATIONAL_REQUIREMENTS',
        'PODCAST',
        'SIMULATOR',
        'ELEARNING'
    ]).optional()
});

export const zSettingsFeature = z.object({
    assistance: zAssistanceFeature.optional(),
    compliance: zComplianceFeature.optional(),
    country: zCountryFeature.optional(),
    enabled: z.boolean().optional(),
    language: zLanguageFeature.optional(),
    location: zLocationFeature.optional()
});

/**
 * Populated when the smart-answer pipeline failed to produce an answer.
 */
export const zSmartAnswersError = z.object({
    code: z.enum([
        'MAXIMUM_TOKENS_EXCEEDED',
        'CONTENT_BLOCKED',
        'UNHANDLED_ERROR',
        'QUESTION_NOT_SUPPORTED'
    ]),
    questionClassification: z.enum([
        'OK',
        'LEGAL_LIABILITY',
        'FOOD_SAFETY'
    ]).optional()
});

/**
 * Response containing an AI-generated answer grounded in retrieved sources.
 */
export const zAnswerResponse = z.object({
    answer: z.string().nullish(),
    error: zSmartAnswersError.optional(),
    observationId: z.string(),
    queryId: z.string(),
    sources: z.array(zAnswerSource).nullish(),
    traceId: z.string()
});

/**
 * The original search parameters used for the smart answers search feature.
 */
export const zSmartAnswersFeature = z.object({
    enabled: z.boolean().nullish(),
    includeOffMenuResources: z.boolean().nullish().default(false),
    includeTestResources: z.boolean().nullish().default(false),
    minAnswerSourceConfidence: z.enum([
        'VERY_HIGH',
        'HIGH',
        'MEDIUM',
        'LOW',
        'NOT_AVAILABLE',
        'UNKNOWN_TO_SYSTEM'
    ]).optional(),
    model: z.enum([
        'GEMINI_2_5_FLASH',
        'GEMINI_2_5_FLASH_LITE',
        'GEMINI_3_1_FLASH_LITE',
        'GEMINI_3_5_FLASH',
        'GEMINI_3_5_FLASH_LITE'
    ]).optional(),
    promptInstructions: z.string().nullish(),
    temperature: z.number().gte(0).lte(2).nullish()
});

/**
 * Includes the smart answers search result. Will be null when the smart answers feature was not enabled.
 */
export const zSmartAnswersResult = z.object({
    answer: z.string().optional(),
    error: zSmartAnswersError.optional(),
    parameters: zSmartAnswersFeature,
    queryId: z.string(),
    sources: z.array(zAnswerSource).optional(),
    traceId: z.string()
});

export const zSearchResponse = z.object({
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    pageSize: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    queryId: z.string(),
    results: z.array(zSearchDocument).nullish(),
    smart: zSmartAnswersResult.optional(),
    spellingSuggestions: z.array(z.string()).nullish(),
    totalResults: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
});

/**
 * Thumb rating and written feedback for a smart search answer trace.
 */
export const zSmartSearchFeedbackRequest = z.object({
    comment: z.string().min(0).max(2000).nullable(),
    value: z.int().gte(0).lte(1)
});

export const zSmartSearchManagementFeature = z.object({
    enabled: z.boolean().optional(),
    status: z.boolean().optional()
});

/**
 * Smart search opt-in status for a single restaurant owner.
 */
export const zSmartSearchOwner = z.object({
    optIn: z.boolean(),
    ownerId: z.string()
});

/**
 * Smart search opt-in status for restaurants the user can manage.
 */
export const zSmartSearchOwnersResponse = z.object({
    owners: z.array(zSmartSearchOwner)
});

/**
 * Request to opt in or out of smart search for one or more restaurants.
 */
export const zSmartSearchUpdateRequest = z.object({
    all: z.boolean(),
    optIn: z.boolean(),
    ownerIds: z.array(z.string().min(1).max(50)).min(0).max(100).optional()
});

/**
 * Represents the heartbeat interval to update a step's duration by.
 */
export const zStepHeartBeatRequest = z.object({
    intervalInSeconds: z.int().gte(1).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
});

export const zSubcategory = z.object({
    displayIndex: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    id: z.string(),
    lastModified: z.iso.datetime(),
    name: z.string(),
    subtitles: z.array(z.string()).optional()
});

export const zSubtitle = z.object({
    displayIndex: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    documents: z.array(z.string()).optional(),
    id: z.string(),
    lastModified: z.iso.datetime(),
    name: z.string()
});

export const zBrowseResponse = z.object({
    categories: z.array(zCategory).optional(),
    documents: z.array(zBrowseDocument).optional(),
    subcategories: z.array(zSubcategory).optional(),
    subtitles: z.array(zSubtitle).optional()
});

/**
 * Represents a support-center system plan.
 */
export const zSystemPlan = z.object({
    businessModel: z.enum([
        'LICENSEE',
        'FRANCHISEE',
        'ALL'
    ]),
    category: z.string().optional(),
    created: z.iso.datetime(),
    description: z.record(z.string(), z.string()).optional(),
    estimatedTimeToCompleteInMinutes: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    expireAfterCompletionOffsetInDays: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    featured: z.boolean(),
    id: z.string(),
    modified: z.iso.datetime(),
    name: z.record(z.string(), z.string()),
    readonly: z.boolean(),
    readonlySubscriptionSettings: zReadonlySubscriptionSettings.optional(),
    reassignBeforeExpirationOffsetInDays: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    totalSteps: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    type: z.enum([
        'STORE',
        'TEMPLATE',
        'COMPLIANCE',
        'ANCHOR'
    ])
});

/**
 * Task step within a plan.
 */
export const zTaskStep = z.object({
    id: z.string(),
    name: z.record(z.string(), z.string()),
    note: z.record(z.string(), z.string()).optional(),
    type: z.enum(['task']),
    urls: z.array(zPlanUrlSet).optional()
});

export const zTeamMemberFeature = z.object({
    enabled: z.boolean().optional()
});

export const zReportingFeature = z.object({
    compliance: zComplianceFeature.optional(),
    enabled: z.boolean().optional(),
    licensee: zLicenseeFeature.optional(),
    plans: zReportingPlansFeature.optional(),
    teamMember: zTeamMemberFeature.optional()
});

export const zFeatureSet = z.object({
    admin: zAdminFeature.optional(),
    analytics: zAnalyticsFeature.optional(),
    monitoring: zMonitoringFeature.optional(),
    plans: zPlansFeature.optional(),
    quizzes: zQuizzesFeature.optional(),
    reporting: zReportingFeature.optional(),
    rum: zRumFeature.optional(),
    settings: zSettingsFeature.optional(),
    'smart-search-management': zSmartSearchManagementFeature.optional()
});

/**
 * Represents the request used to update plans status and all its steps for passed in users to complete.
 */
export const zTrainTogetherMarkPlanAsCompleteRequest = z.object({
    userIds: z.array(z.string()).min(1)
});

/**
 * Represents the request used to update the duration for passed in users.
 */
export const zTrainTogetherStepHeartBeatRequest = z.object({
    intervalInSeconds: z.int().gte(1).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    userIds: z.array(z.string()).min(1)
});

/**
 * Represents the request used to update plans step status for passed in users.
 */
export const zTrainTogetherUpdateStepStatusRequest = z.object({
    status: z.enum(['INCOMPLETE', 'COMPLETE']),
    userIds: z.array(z.string()).min(1)
});

/**
 * Strings which have been translated from the original language to the target language.
 */
export const zTranslation = z.object({
    id: z.string(),
    originalText: z.string(),
    translatedText: z.string()
});

/**
 * Lines of text to be translated.
 */
export const zTranslationRequestText = z.object({
    id: z.string().min(1).regex(/^(?!\s*$).+/),
    value: z.string().min(0).max(3000).regex(/^(?!\s*$).+/)
});

export const zTranslationRequest = z.object({
    sourceLanguage: z.string().min(1).regex(/^(?!\s*$).+/),
    targetLanguage: z.string().min(1).regex(/^(?!\s*$).+/),
    texts: z.array(zTranslationRequestText).min(1)
});

export const zTranslationResponse = z.object({
    sourceLanguage: z.string(),
    targetLanguage: z.string(),
    translations: z.array(zTranslation)
});

/**
 * Unauthorized Error
 *
 * Error model with http status UNAUTHORIZED (401)
 */
export const zUnauthorizedError = z.object({
    detail: z.string().optional(),
    error: z.string().optional(),
    instance: z.string().optional(),
    message: z.string().optional(),
    path: z.string().optional(),
    status: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    timestamp: z.iso.datetime().optional(),
    title: z.string().optional(),
    tracing: z.object({
        'X-B3-Sampled': z.string().optional(),
        'X-B3-SpanId': z.string().optional(),
        'X-B3-TraceId': z.string().optional()
    }).optional(),
    type: z.string().optional()
});

/**
 * Represents the request used to update users due date for a plan.
 */
export const zUpdatePlanAssignmentDueDateRequest = z.object({
    dueDate: z.iso.date().optional(),
    userIds: z.array(z.string()).min(1)
});

/**
 * URLs for the reference.
 */
export const zUrl = z.object({
    contentApiUrl: z.string().optional(),
    contentUrl: z.string(),
    language: z.string(),
    printUrl: z.string().nullish()
});

/**
 * Represents a reference for a resource.
 */
export const zPlanResourceReference = z.object({
    businessEntity: z.string(),
    businessModel: z.string().optional(),
    country: z.string(),
    createdAt: z.iso.datetime(),
    description: z.string(),
    format: z.string(),
    id: z.string(),
    language: z.string(),
    legacyId: z.string().optional(),
    marketTest: z.boolean().optional(),
    name: z.string(),
    sourceId: z.string(),
    sourceSystem: z.string(),
    tags: z.array(z.string()),
    updatedAt: z.iso.datetime(),
    urls: z.array(zUrl)
});

/**
 * Represents a resource.
 */
export const zPlanResource = z.object({
    id: z.string(),
    name: z.record(z.string(), z.string()),
    references: z.array(zPlanResourceReference).optional(),
    type: z.string().optional()
}).readonly();

/**
 * Document step within a plan.
 */
export const zDocumentStep = z.object({
    available: z.boolean().readonly().optional(),
    id: z.string(),
    name: z.record(z.string(), z.string()),
    reference: z.string(),
    resource: zPlanResource.optional(),
    type: z.enum(['document'])
});

/**
 * Polymorphic plan content step.
 */
export const zContentStep = z.discriminatedUnion('type', [
    zDocumentStep.extend({ type: z.literal('document') }),
    zQuizStep.extend({ type: z.literal('quiz') }),
    zTaskStep.extend({ type: z.literal('task') })
]);

/**
 * Represents a section of a plan.
 */
export const zPlanSection = z.object({
    id: z.string(),
    name: z.record(z.string(), z.string()),
    steps: z.array(zContentStep).optional()
});

/**
 * Represents the content of a plan
 */
export const zPlanContent = z.object({
    sections: z.array(zPlanSection).optional(),
    steps: z.array(zContentStep).optional()
});

/**
 * Represents a plan or plan entity.
 */
export const zPlan = z.object({
    activeCertificates: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    allowTrainTogether: z.boolean(),
    assignedUsers: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    autoAssign: z.boolean(),
    category: z.string().optional(),
    completedUsers: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    content: zPlanContent.optional(),
    created: z.iso.datetime(),
    createdBy: z.string(),
    description: z.record(z.string(), z.string()).optional(),
    dueDateOffsetInDays: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    estimatedTimeToCompleteInMinutes: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    expireAfterCompletionOffsetInDays: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    id: z.string(),
    latestSummaryReports: z.array(zPlanUserSummaryReport).optional(),
    legacyId: z.string().optional(),
    modified: z.iso.datetime(),
    modifiedBy: z.string(),
    name: z.record(z.string(), z.string()),
    ownerId: z.string(),
    ownerType: z.enum([
        'SUPPORT_CENTER',
        'LOCATION',
        'OPERATOR',
        'SELF'
    ]),
    permissions: zPlanPermissions.optional(),
    readonly: z.boolean(),
    readonlySubscriptionSettings: zReadonlySubscriptionSettings.optional(),
    reassignBeforeExpirationOffsetInDays: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    status: z.enum(['INACTIVE', 'ACTIVE']),
    totalSteps: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    type: z.enum([
        'STORE',
        'TEMPLATE',
        'COMPLIANCE',
        'ANCHOR'
    ])
});

/**
 * ContentReferences
 *
 * Content reference fields included in a resource swap preview.
 */
export const zResourceSwapDiffContentReference = z.object({
    attributes: z.array(zAttribute).optional(),
    businessEntity: z.enum([
        'CFA',
        'LBM',
        'TG',
        'BAY_CENTER',
        'CFA_SUPPLY'
    ]).optional(),
    businessModel: z.enum([
        'FRANCHISEE',
        'LIC',
        'CORP'
    ]).optional(),
    country: z.string().optional(),
    description: z.string().optional(),
    format: z.enum([
        'HTML',
        'PDF',
        'VIDEO',
        'COURSE',
        'SCORM'
    ]).optional(),
    id: z.string(),
    language: z.string().optional(),
    legacyId: z.string().optional(),
    name: z.array(zName).optional(),
    sourceId: z.string().optional(),
    sourceSystem: z.enum([
        'XYLEME',
        'TRIDION',
        'BRIGHTCOVE',
        'GAME'
    ]).optional(),
    urls: z.array(zUrl).optional()
});

/**
 * Eventual shape of the persistent resource after swap and downstream Tridion publication sync (not the immediate POST /resources/swap state). Keeps persistent id, legacyId, and format; adopts temporary name, type, icon, content references, and sourceSystemId. Name/type/icon are proxied from the temporary resource until Tridion sync applies publication title, type, and icon. Does not include subtitle placements.
 */
export const zResourceSwapDiffAfterSwap = z.object({
    attributes: z.array(zAttribute).optional(),
    contentReferences: z.array(zResourceSwapDiffContentReference),
    format: z.enum([
        'HTML',
        'PDF',
        'VIDEO',
        'COURSE',
        'SCORM'
    ]).optional(),
    icon: z.string().optional(),
    id: z.string(),
    legacyId: z.string().optional(),
    name: z.array(zName).optional(),
    type: z.enum([
        'BRIGHTCOVE',
        'LEARNUPON',
        'PROCEDURE',
        'JOB_AID',
        'GAME',
        'ORG',
        'QUALITY_PHOTOS',
        'VIDEO',
        'PDF',
        'OPERATIONAL_REQUIREMENTS',
        'PODCAST',
        'SIMULATOR',
        'ELEARNING'
    ]).optional()
});

/**
 * Resource projection for side-by-side swap comparison.
 */
export const zResourceSwapDiffResource = z.object({
    attributes: z.array(zAttribute).optional(),
    contentReferences: z.array(zResourceSwapDiffContentReference),
    format: z.enum([
        'HTML',
        'PDF',
        'VIDEO',
        'COURSE',
        'SCORM'
    ]).optional(),
    icon: z.string().optional(),
    id: z.string(),
    legacyId: z.string().optional(),
    name: z.array(zName).optional(),
    subtitlePlacements: z.array(zResourceSwapCategory),
    type: z.enum([
        'BRIGHTCOVE',
        'LEARNUPON',
        'PROCEDURE',
        'JOB_AID',
        'GAME',
        'ORG',
        'QUALITY_PHOTOS',
        'VIDEO',
        'PDF',
        'OPERATIONAL_REQUIREMENTS',
        'PODCAST',
        'SIMULATOR',
        'ELEARNING'
    ]).optional()
});

/**
 * Side-by-side resource swap preview with an optional after-swap projection.
 */
export const zResourceSwapDiffResponse = z.object({
    afterSwap: zResourceSwapDiffAfterSwap.optional(),
    persistentResource: zResourceSwapDiffResource.optional(),
    temporaryResource: zResourceSwapDiffResource.optional()
});

/**
 * Sections of the plan.
 */
export const zSection = z.object({
    id: z.string().optional(),
    name: z.record(z.string(), z.string()).optional(),
    steps: z.array(zContentStep).optional()
});

/**
 * Content of the plan including sections and steps.
 */
export const zContent = z.object({
    sections: z.array(zSection).optional(),
    steps: z.array(zContentStep).optional()
});

/**
 * Represents a plan update request.
 */
export const zPlanUpdateRequest = z.object({
    category: z.string().optional(),
    content: zContent.optional(),
    description: z.record(z.string(), z.string()).optional(),
    estimatedTimeToCompleteInMinutes: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    name: z.record(z.string(), z.string())
});

/**
 * User permission flags derived from token roles and restaurant opt-in status.
 */
export const zUserPermissions = z.object({
    smartSearch: z.boolean()
});

/**
 * The list of user plan assignment summaries sorted by oldest first.
 */
export const zUserPlanAssignmentSummary = z.object({
    category: z.string(),
    description: z.record(z.string(), z.string()).optional(),
    dueDate: z.iso.date().optional(),
    id: z.string(),
    latestCompletionReport: zAssignmentLatestCompletionReport.optional(),
    name: z.record(z.string(), z.string()),
    ownerId: z.string(),
    ownerType: z.enum([
        'SUPPORT_CENTER',
        'LOCATION',
        'OPERATOR',
        'SELF'
    ]),
    stepsComplete: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    stepsTotal: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    type: z.enum([
        'STORE',
        'TEMPLATE',
        'COMPLIANCE',
        'ANCHOR'
    ])
});

export const zUserPlanAssignmentSummaries = z.object({
    plans: z.array(zUserPlanAssignmentSummary)
});

/**
 * Represents the user's progress on a plan.
 */
export const zUserPlanStatus = z.object({
    category: z.string(),
    completedSteps: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).default(0),
    completionDate: z.iso.date().optional(),
    description: z.record(z.string(), z.string()).optional(),
    dueDate: z.iso.date().optional(),
    latestCompletionReport: zAssignmentLatestCompletionReport.optional(),
    planCreated: z.iso.datetime().optional(),
    planId: z.string(),
    planModified: z.iso.datetime().optional(),
    planName: z.record(z.string(), z.string()),
    planStatus: z.enum([
        'NOT_STARTED',
        'IN_PROGRESS',
        'COMPLETED',
        'UNASSIGNED'
    ]),
    planType: z.enum([
        'STORE',
        'TEMPLATE',
        'COMPLIANCE',
        'ANCHOR'
    ]),
    timeTakenInSeconds: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).default(BigInt(0)),
    totalSteps: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).default(0)
});

/**
 * Represents a summary of all user's plan progress on all active plans the logged in user can manage.
 */
export const zUserPlanSummaryReport = z.object({
    plansAssigned: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    plansCompleted: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    user: zPathwayUserReport
});

/**
 * Represents a user's plan's with the respective plan assigment.
 */
export const zUserPlans = z.object({
    assignments: z.array(zPlanAssignment).optional(),
    plan: zPlan.optional()
});

export const zUserPreferencesEntity = z.object({
    country: z.string().optional(),
    language: z.string().optional(),
    location: z.string().optional(),
    userId: z.string().optional()
});

export const zUserProfile = z.object({
    audience: z.string().optional(),
    country: z.string().optional(),
    id: z.string().optional(),
    language: z.string().optional(),
    locations: z.array(zPermittedLocation).optional(),
    permissions: zUserPermissions.optional(),
    selectedLocation: z.string().optional()
});

export const zAuthResponse = z.object({
    cdn: z.array(zCloudFrontCookieGroup).optional(),
    features: zFeatureSet.optional(),
    user: zUserProfile.optional()
});

/**
 * Represents a summary of all the passed in user's plan progress.
 */
export const zUserSummaryReport = z.object({
    planStatus: z.array(zUserPlanStatus),
    user: zPathwayUserReport
});

/**
 * AssignUsersToCheckList
 */
export const zUsersToCourseRequest = z.object({
    assignCourse: z.boolean().optional(),
    userIds: z.array(z.string()).optional()
});

/**
 * Document step within a plan.
 */
export const zDocumentStepWritable = z.object({
    id: z.string(),
    name: z.record(z.string(), z.string()),
    reference: z.string(),
    resource: zPlanResource.optional(),
    type: z.enum(['document'])
});

/**
 * Quiz step within a plan.
 */
export const zQuizStepWritable = z.object({
    id: z.string(),
    name: z.record(z.string(), z.string()),
    quizId: z.string().min(1).regex(/^(?!\s*$).+/),
    type: z.enum(['quiz'])
});

/**
 * Polymorphic plan content step.
 */
export const zContentStepWritable = z.discriminatedUnion('type', [
    zDocumentStepWritable.extend({ type: z.literal('document') }),
    zQuizStepWritable.extend({ type: z.literal('quiz') }),
    zTaskStep.extend({ type: z.literal('task') })
]);

/**
 * Represents a section of a plan.
 */
export const zPlanSectionWritable = z.object({
    id: z.string(),
    name: z.record(z.string(), z.string()),
    steps: z.array(zContentStepWritable).optional()
});

/**
 * Represents the content of a plan
 */
export const zPlanContentWritable = z.object({
    sections: z.array(zPlanSectionWritable).optional(),
    steps: z.array(zContentStepWritable).optional()
});

/**
 * Represents a plan or plan entity.
 */
export const zPlanWritable = z.object({
    activeCertificates: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    allowTrainTogether: z.boolean(),
    assignedUsers: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    autoAssign: z.boolean(),
    category: z.string().optional(),
    completedUsers: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    content: zPlanContentWritable.optional(),
    created: z.iso.datetime(),
    createdBy: z.string(),
    description: z.record(z.string(), z.string()).optional(),
    dueDateOffsetInDays: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    estimatedTimeToCompleteInMinutes: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    expireAfterCompletionOffsetInDays: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    id: z.string(),
    latestSummaryReports: z.array(zPlanUserSummaryReport).optional(),
    legacyId: z.string().optional(),
    modified: z.iso.datetime(),
    modifiedBy: z.string(),
    name: z.record(z.string(), z.string()),
    ownerId: z.string(),
    ownerType: z.enum([
        'SUPPORT_CENTER',
        'LOCATION',
        'OPERATOR',
        'SELF'
    ]),
    permissions: zPlanPermissions.optional(),
    readonly: z.boolean(),
    readonlySubscriptionSettings: zReadonlySubscriptionSettings.optional(),
    reassignBeforeExpirationOffsetInDays: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    status: z.enum(['INACTIVE', 'ACTIVE']),
    totalSteps: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    type: z.enum([
        'STORE',
        'TEMPLATE',
        'COMPLIANCE',
        'ANCHOR'
    ])
});

/**
 * Sections of the plan.
 */
export const zSectionWritable = z.object({
    id: z.string().optional(),
    name: z.record(z.string(), z.string()).optional(),
    steps: z.array(zContentStepWritable).optional()
});

/**
 * Content of the plan including sections and steps.
 */
export const zContentWritable = z.object({
    sections: z.array(zSectionWritable).optional(),
    steps: z.array(zContentStepWritable).optional()
});

/**
 * Represents a plan update request.
 */
export const zPlanUpdateRequestWritable = z.object({
    category: z.string().optional(),
    content: zContentWritable.optional(),
    description: z.record(z.string(), z.string()).optional(),
    estimatedTimeToCompleteInMinutes: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    name: z.record(z.string(), z.string())
});

/**
 * Represents a user's plan's with the respective plan assigment.
 */
export const zUserPlansWritable = z.object({
    assignments: z.array(zPlanAssignment).optional(),
    plan: zPlanWritable.optional()
});

export const zCreateAnswerBody = zAnswerRequest;

/**
 * OK
 */
export const zCreateAnswerResponse = zAnswerResponse;

export const zRunDatasetExperimentBody = zDatasetExperimentRequest;

/**
 * Accepted
 */
export const zRunDatasetExperimentResponse = zDatasetExperimentResponse;

/**
 * OK
 */
export const zGetExperimentsConfigResponse = zExperimentsConfigResponse;

/**
 * OK
 */
export const zGetAuthResponse = zAuthResponse;

export const zBrowseStructureQuery = z.object({
    country: z.string().optional(),
    language: z.string().optional()
});

/**
 * OK
 */
export const zBrowseStructureResponse = zBrowseResponse;

export const zGetCategoriesByCountryCodeQuery = z.object({
    country: z.string().optional()
});

/**
 * OK
 */
export const zGetCategoriesByCountryCodeResponse = zIntlCategoriesDto;

export const zSaveCategoriesBody = z.array(zIntlCategoryEntity);

/**
 * No Content
 */
export const zSaveCategoriesResponse = z.void();

export const zSaveCategoryBody = zIntlCategoryDto;

/**
 * No Content
 */
export const zSaveCategoryResponse = z.void();

export const zGetCategoryV2Path = z.object({
    id: z.string()
});

export const zGetCategoryV2Query = z.object({
    country: z.string().optional()
});

/**
 * OK
 */
export const zGetCategoryV2Response = zIntlCategory;

export const zDeleteCategoryByCountryCodeAndIdPath = z.object({
    country: z.string(),
    id: z.string()
});

/**
 * No Content
 */
export const zDeleteCategoryByCountryCodeAndIdResponse = z.void();

export const zGetCategoryPath = z.object({
    id: z.string()
});

export const zGetCategoryQuery = z.object({
    country: z.string().optional()
});

/**
 * OK
 */
export const zGetConfigurationResponse = zFrontEndPropertiesResponse;

export const zGetAllCoursesQuery = z.object({
    isAdmin: z.boolean().optional().default(false),
    type: z.string().optional().default('')
});

/**
 * OK
 */
export const zGetAllCoursesResponse = z.array(zCourseEntity);

export const zAddCourseBody = zCourseEntity;

/**
 * OK
 */
export const zAddCourseResponse = zCourseEntity;

export const zAssignUsersToChecklistBody = zUsersToCourseRequest;

export const zAssignUsersToChecklistPath = z.object({
    courseId: z.string()
});

export const zListEnrollmentsByCoursePath = z.object({
    courseId: z.string()
});

export const zListEnrollmentsByCourseQuery = z.object({
    'List of locations to filter': z.string().optional()
});

/**
 * OK
 */
export const zListEnrollmentsByCourseResponse = zAssignableCourseResult;

/**
 * OK
 */
export const zGetComplianceCoursesResponse = z.array(zCourse);

export const zGenerateCourseReportPath = z.object({
    courseId: z.string()
});

export const zGenerateCourseReportQuery = z.object({
    location: z.array(z.string())
});

/**
 * OK
 */
export const zGenerateCourseReportResponse = zCourseReportDto;

export const zGetOperatorCourseSettingsQuery = z.object({
    operatorId: z.string()
});

/**
 * Updated
 */
export const zGetOperatorCourseSettingsResponse = z.record(z.string(), zComplianceConfigurationDto);

export const zSetOperatorCourseSettingPath = z.object({
    courseId: z.string(),
    enable: z.string()
});

export const zSetOperatorCourseSettingQuery = z.object({
    operatorId: z.string()
});

export const zGetSqsslPath = z.object({
    courseId: z.string()
});

export const zGetSqsslQuery = z.object({
    lang: z.string().optional()
});

/**
 * OK
 */
export const zGetSqsslResponse = z.record(z.string(), z.string());

export const zSynchronizeUserPath = z.object({
    userId: z.string()
});

export const zLearnUponWebhookBody = z.string();

/**
 * No Content
 */
export const zLearnUponWebhookResponse = z.void();

export const zDeleteCoursePath = z.object({
    id: z.string()
});

export const zUpdateCourseBody = zCourseEntity;

export const zUpdateCoursePath = z.object({
    id: z.string()
});

/**
 * OK
 */
export const zUpdateCourseResponse = zCourseEntity;

export const zGetCourseByIdPath = z.object({
    itemId: z.string()
});

/**
 * OK
 */
export const zGetCourseByIdResponse = zCourseEntity;

export const zUpdateUserComplianceCourseDurationBody = zCourseHeartbeat;

export const zUpdateUserComplianceCourseDurationPath = z.object({
    pathwayCourseId: z.string()
});

export const zSaveDocumentsBody = zDocumentsRequest;

/**
 * No Content
 */
export const zDeleteDocumentResponse = z.void();

export const zGetDocumentPath = z.object({
    itemId: z.string()
});

/**
 * OK
 */
export const zGetDocumentResponse = zDocumentDto;

/**
 * OK
 */
export const zGetCategoryIconsResponse = z.array(z.string());

/**
 * OK
 */
export const zGetProcedureIconsResponse = z.array(z.string());

export const zGetPlansSummaryQuery = z.object({
    locationNumbers: z.array(z.string()).optional(),
    status: z.enum(['INACTIVE', 'ACTIVE']).optional()
});

/**
 * OK
 */
export const zGetPlansSummaryResponse = z.array(zPlanReport);

export const zGetPlanReportPath = z.object({
    planId: z.string()
});

export const zGetPlanReportQuery = z.object({
    locationNumbers: z.array(z.string()).optional()
});

/**
 * OK
 */
export const zGetPlanReportResponse = zPlanUsersReport;

export const zGetUsersSummaryReportQuery = z.object({
    locationNumbers: z.array(z.string())
});

/**
 * OK
 */
export const zGetUsersSummaryReportResponse = z.array(zUserPlanSummaryReport);

export const zGetUserSummaryReportPath = z.object({
    userId: z.string()
});

export const zGetUserSummaryReportQuery = z.object({
    locationNumber: z.string().optional()
});

/**
 * OK
 */
export const zGetUserSummaryReportResponse = zUserSummaryReport;

export const zGetManagedPlansQuery = z.object({
    status: z.enum(['INACTIVE', 'ACTIVE']).optional()
});

/**
 * OK
 */
export const zGetManagedPlansResponse = z.array(zPlan);

export const zCreatePlanBody = zPlanCreateRequest;

/**
 * Created
 */
export const zCreatePlanResponse = zPlan;

/**
 * OK
 */
export const zGetActivePlanAssignmentsResponse = z.array(zUserPlans);

/**
 * OK
 */
export const zGetSystemPlansResponse = z.array(zSystemPlan);

export const zGetPlanAndAssignmentsPath = z.object({
    planId: z.string()
});

/**
 * OK
 */
export const zGetPlanAndAssignmentsResponse = zUserPlans;

export const zUpdatePlanBody = zPlanUpdateRequestWritable;

export const zUpdatePlanPath = z.object({
    planId: z.string()
});

/**
 * OK
 */
export const zUpdatePlanResponse = zPlan;

export const zUnassignUsersBody = zPlanUnassignmentRequest;

export const zUnassignUsersPath = z.object({
    planId: z.string()
});

/**
 * No Content
 */
export const zUnassignUsersResponse = z.void();

export const zAssignUsersBody = zPlanAssignmentRequest;

export const zAssignUsersPath = z.object({
    planId: z.string()
});

export const zPatchAutoAssignBody = zPatchAutoAssignRequest;

export const zPatchAutoAssignPath = z.object({
    planId: z.string()
});

/**
 * No Content
 */
export const zPatchAutoAssignResponse = z.void();

export const zClonePlanBody = zPlanCloneRequest;

export const zClonePlanPath = z.object({
    planId: z.string()
});

/**
 * Created
 */
export const zClonePlanResponse = zPlan;

export const zCloneAsSystemPlanBody = zCloneAsSystemPlanRequest;

export const zCloneAsSystemPlanPath = z.object({
    planId: z.string()
});

/**
 * Created
 */
export const zCloneAsSystemPlanResponse = zPlan;

export const zUpdateDueDateBody = zUpdatePlanAssignmentDueDateRequest;

export const zUpdateDueDatePath = z.object({
    planId: z.string()
});

/**
 * No Content
 */
export const zUpdateDueDateResponse = z.void();

export const zMarkPlanAsCompletePath = z.object({
    planId: z.string()
});

/**
 * No Content
 */
export const zMarkPlanAsCompleteResponse = z.void();

export const zPatchPlanNameBody = zPlanNamePatchRequest;

export const zPatchPlanNamePath = z.object({
    planId: z.string()
});

/**
 * No Content
 */
export const zPatchPlanNameResponse = z.void();

export const zUpsertReadonlySubscriptionBody = zReadonlySubscriptionRequest;

export const zUpsertReadonlySubscriptionPath = z.object({
    planId: z.string()
});

/**
 * No Content
 */
export const zUpsertReadonlySubscriptionResponse = z.void();

export const zPatchPlanStatusBody = zPatchStatusRequest;

export const zPatchPlanStatusPath = z.object({
    planId: z.string()
});

/**
 * No Content
 */
export const zPatchPlanStatusResponse = z.void();

export const zResetPlanStepsBody = zResetPlanStepsRequest;

export const zResetPlanStepsPath = z.object({
    planId: z.string()
});

/**
 * No Content
 */
export const zResetPlanStepsResponse = z.void();

export const zHeartbeatBody = zStepHeartBeatRequest;

export const zHeartbeatPath = z.object({
    planId: z.string(),
    stepId: z.string()
});

/**
 * No Content
 */
export const zHeartbeatResponse = z.void();

export const zUpdateStepStatusBody = zAssignedStepStatusRequest;

export const zUpdateStepStatusPath = z.object({
    planId: z.string(),
    stepId: z.string()
});

/**
 * No Content
 */
export const zUpdateStepStatusResponse = z.void();

export const zHeartbeatTrainTogetherBody = zTrainTogetherStepHeartBeatRequest;

export const zHeartbeatTrainTogetherPath = z.object({
    planId: z.string(),
    stepId: z.string()
});

/**
 * No Content
 */
export const zHeartbeatTrainTogetherResponse = z.void();

export const zTrainTogetherUpdateStepStatusBody = zTrainTogetherUpdateStepStatusRequest;

export const zTrainTogetherUpdateStepStatusPath = z.object({
    planId: z.string(),
    stepId: z.string()
});

/**
 * No Content
 */
export const zTrainTogetherUpdateStepStatusResponse = z.void();

export const zTrainTogetherMarkPlanAsCompleteBody = zTrainTogetherMarkPlanAsCompleteRequest;

export const zTrainTogetherMarkPlanAsCompletePath = z.object({
    planId: z.string()
});

/**
 * No Content
 */
export const zTrainTogetherMarkPlanAsCompleteResponse = z.void();

/**
 * OK
 */
export const zGetQuizzesResponse = z.array(zQuiz);

export const zCreateQuizBody = zQuizCreateRequest;

/**
 * Created
 */
export const zCreateQuizResponse = zQuizCreateResponse;

export const zHardDeleteQuizPath = z.object({
    quizId: z.string()
});

export const zHardDeleteQuizQuery = z.object({
    typeFormId: z.string()
});

export const zDeleteQuizPath = z.object({
    quizId: z.string()
});

export const zGetQuizDetailsPath = z.object({
    quizId: z.string().min(1)
});

/**
 * OK
 */
export const zGetQuizDetailsResponse = zQuizDetail;

export const zUpdateQuizBody = zQuizUpdateRequest;

export const zUpdateQuizPath = z.object({
    quizId: z.string()
});

/**
 * OK
 */
export const zUpdateQuizResponse = zQuizUpdateResponse;

export const zPatchQuizNameBody = zQuizNamePatchRequest;

export const zPatchQuizNamePath = z.object({
    quizId: z.string()
});

/**
 * No Content
 */
export const zPatchQuizNameResponse = z.void();

export const zDiffQuery = z.object({
    persistentResourceId: z.string().min(1),
    temporaryResourceId: z.string().min(1)
});

/**
 * OK
 */
export const zDiffResponse = zResourceSwapDiffResponse;

export const zSwapBody = zResourceSwapRequest;

/**
 * OK
 */
export const zSwapResponse = zResourceSwapResponse;

export const zRewritePlanReferencesBody = zPlanResourceReferenceRewriteRequest;

/**
 * Accepted
 */
export const zRewritePlanReferencesResponse = zPlanResourceReferenceRewriteResponse;

export const zGetResourcePath = z.object({
    id: z.string()
});

export const zGetResourceQuery = z.object({
    country: z.string().optional(),
    language: z.string().optional()
});

/**
 * OK
 */
export const zGetResourceResponse = zResource;

export const zSearchQuery = z.object({
    query: z.string().min(1).max(1000),
    country: z.string(),
    language: z.string(),
    pageNumber: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional().default(1),
    'smart.enabled': z.boolean().optional(),
    'smart.model': z.enum([
        'GEMINI_2_5_FLASH',
        'GEMINI_2_5_FLASH_LITE',
        'GEMINI_3_1_FLASH_LITE',
        'GEMINI_3_5_FLASH',
        'GEMINI_3_5_FLASH_LITE'
    ]).optional(),
    'smart.promptInstructions': z.string().optional(),
    'smart.minAnswerSourceConfidence': z.enum([
        'VERY_HIGH',
        'HIGH',
        'MEDIUM',
        'LOW',
        'NOT_AVAILABLE',
        'UNKNOWN_TO_SYSTEM'
    ]).optional(),
    'smart.temperature': z.number().gte(0).lte(2).optional(),
    'smart.includeTestResources': z.boolean().optional().default(false),
    'smart.includeOffMenuResources': z.boolean().optional().default(false)
});

/**
 * OK
 */
export const zSearchResponse2 = zSearchResponse;

export const zSearchClickFeedbackQuery = z.object({
    resultId: z.string().min(1),
    queryId: z.string().min(1)
});

/**
 * OK
 */
export const zGetSmartSearchLocationsResponse = zSmartSearchOwnersResponse;

export const zUpdateSmartSearchOptInBody = zSmartSearchUpdateRequest;

/**
 * No Content
 */
export const zUpdateSmartSearchOptInResponse = z.void();

export const zUpsertSmartSearchFeedbackBody = zSmartSearchFeedbackRequest;

export const zUpsertSmartSearchFeedbackPath = z.object({
    traceId: z.string().min(1)
});

/**
 * No Content
 */
export const zUpsertSmartSearchFeedbackResponse = z.void();

export const zGetTranslationsBody = zTranslationRequest;

/**
 * OK
 */
export const zGetTranslationsResponse = zTranslationResponse;

export const zGetUsersForLocationsQuery = z.object({
    locationNumbers: z.array(z.string()).optional().default([])
});

/**
 * OK
 */
export const zGetUsersForLocationsResponse = z.array(zPathwayUser);

export const zGetUsersQuery = z.object({
    locations: z.array(z.string()).optional().default([])
});

/**
 * OK
 */
export const zGetUsersResponse = z.array(zIdentityUser);

/**
 * OK
 */
export const zGetOperatorsResponse = z.array(zOperatorDto);

/**
 * OK
 */
export const zGetUserPreferencesResponse = zUserPreferencesEntity;

export const zSaveUserPreferencesBody = zUserPreferencesEntity;

/**
 * OK
 */
export const zSaveUserPreferencesResponse = zUserPreferencesEntity;

export const zGetUserPlanAssignmentSummariesPath = z.object({
    userId: z.string()
});

export const zGetUserPlanAssignmentSummariesQuery = z.object({
    assignmentStatuses: z.array(z.enum([
        'NOT_STARTED',
        'IN_PROGRESS',
        'COMPLETED',
        'UNASSIGNED'
    ])).optional().default(['NOT_STARTED', 'IN_PROGRESS']),
    ownerId: z.string()
});

/**
 * OK
 */
export const zGetUserPlanAssignmentSummariesResponse = zUserPlanAssignmentSummaries;

export const zWebhookQuizBody = z.string();

export const zWebhookQuizHeaders = z.object({
    'Typeform-Signature': z.string()
});
